import Validation from '@core/logic/Validation'

export default class BasicProductValidation extends Validation {
  validate (product, index: number, belongsTo: string) {
    this.belongsTo = belongsTo
    const productNamePrefix = 'Product ' + index
    const productNameInfo = product.productName ? productNamePrefix + ' ( ' + product.productName + ' )' : productNamePrefix
    const { getMessages, ADDMANDATORY, REQUIRE } = this.validator()

    if (product.type === 'investment') { // investment main account only check for client choice
      ADDMANDATORY(REQUIRE(product.clientChoice, `${productNameInfo}'s Client Choice needs to be filled.`), ['Client\'s Decision'])
    } else {
      ADDMANDATORY(REQUIRE(product.priority, `${productNameInfo}'s priority to be filled.`), ['Product Recommendations'])
      ADDMANDATORY(REQUIRE(product.productName, `${productNameInfo}'s plan name needs to be filled.`), ['Product Recommendations'])
      ADDMANDATORY(REQUIRE(product.frequency, `${productNameInfo}'s frequency needs to be filled.`), ['Product Recommendations'])

      if (product.type === 'insurance') {
        ADDMANDATORY(REQUIRE(product.clientIndex, `${productNameInfo}'s owner needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.lifeAssured, `${productNameInfo}'s life assured to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.premiumAmount, `${productNameInfo}'s premium amount needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.sumAssured, `${productNameInfo}'s sum assured needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.paymentMode, `${productNameInfo}'s payment mode needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.policyTerm, `${productNameInfo}'s policy term needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.premiumTerm, `${productNameInfo}'s premium term needs to be filled.`), ['Product Recommendations'])
      } else if (product.type === 'investment-subFunds') {
        ADDMANDATORY(REQUIRE(product.clientIndex, `${productNameInfo}'s owner needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.sumAssured, `${productNameInfo}'s investment amount needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.transactionType, `${productNameInfo}'s type of transactions needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.paymentMode, `${productNameInfo}'s payment mode needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.wrap, `${productNameInfo}'s wrap/non-wrap needs to be filled.`), ['Product Recommendations'])
      } else if (product.type === 'insurance-rider') {
      // rider
        ADDMANDATORY(REQUIRE(product.sumAssured, `${productNameInfo}'s sum assured needs to be filled.`), ['Product Recommendations'])
        ADDMANDATORY(REQUIRE(product.premiumAmount, `${productNameInfo}'s premium amount needs to be filled.`), ['Product Recommendations'])
      }
    }
    return getMessages()
  }
}
